import React, { Component } from 'react';
import '../assets/styling/topbar.css';
import AppUtils from '../apputils';
import { PnkConnect } from '../pnk-react/pnk-miniredux';
import Logo from "../assets/images/kinship-logo.svg";
//import $ from 'jquery';

class topbar extends Component {
    constructor(props) {
        super(props)
        this.state = {
            isLoggedin: false,
            current_username: '',
            current_user_id:''
        }
    }
    HandleRouting = (route) => {
        // this.props.PnkStore.SetData('currentUrl',route)
        // this.props.PnkStore.BroadCast();
        AppUtils.HandlePageClick(this.props.componentprops, route)
    }

    Logout = () => {
        sessionStorage.clear();
        localStorage.removeItem('current_user_profile');
        localStorage.removeItem('current_user_login_token');
        localStorage.removeItem('current_user_id');
        localStorage.removeItem('current_user_name');
        localStorage.removeItem('referral_count');
        localStorage.removeItem('current_user_email');
        localStorage.removeItem('current_user_full_name');
        localStorage.removeItem('login_token_expire_time');
        localStorage.removeItem('current_user_pic');
        //this.setState({ loginStatus: 'logout' })
        //   this.props.PnkStore.SetData('loginstatus', false);
        this.setState({
            showdropdown: false
        })
        this.HandleRouting('home');
    }

    // showSubmenu = ()=>{
    //    alert('lll')
    //     $('.dropdown-menu').addClass('toggle');
    // }
    // hideMenu = ()=>{
    // //    $('#submenu-div').removeClass('show');
    // }
    componentDidMount = () => {

      // document.getElementById('submenu').ontouchmove

        if (localStorage.getItem('current_user_name') !== null && localStorage.getItem('current_user_login_token') !== null && localStorage.getItem('current_user_profile') !== null) {

            this.setState({
                showdropdown: true
            })
        }
        else {
            this.setState({
                showdropdown: false
            })
        }
        this.setState({
            current_username: localStorage.getItem('current_user_name'),
            current_user_id:localStorage.getItem('current_user_id')
        
        })

        const loginStatus = this.props.PnkStore.GetData('loginstatus');

        if (loginStatus === true) {
            this.setState({
                showdropdown: true
            })
        }
    }

    render() {
        return (
            <div className="kinship-topbar-main" id="topbar">

                <nav class="navbar navbar-light justify-content-end">
                    <div class="ausaf-nav-1">
                        <a
                            className="btn open-menu"
                            href=""
                            role="button"
                            onClick={this.props.componentprops.AddClass}
                        >
                            <div className="menuBars"></div>
                            <div className="menuBars"></div>
                            <div className="menuBars"></div>
                        </a>
                    </div>
                    <div class="logo-mobile-view" onClick={()=>this.HandleRouting('home')}>
                        <img src={Logo} alt="loading..." />
                    </div>
                    {
                        this.state.showdropdown === false ?
                            <div>
                                <button class="btn mr-2 login-btn" type="button" onClick={() => this.HandleRouting("login")}>Login</button>
                                <button class="btn mr-4 signup-btn" type="button" onClick={() => this.HandleRouting("sign-up")}>Sign up</button>
                            </div>

                            :
                            <div>
                                <div class='account-div-main' style={{ display: 'flex' }}>

                                    <button class="btn mr-2 after-login-btn" type="button"
                                    onClick={() => this.HandleRouting(`user-profile/${this.state.current_user_id}`)}
                                    >{this.state.current_username.slice(0 , this.state.current_username.indexOf(' ') )}</button>
                                 
                                    <a class="nav-link dropdown-toggle topbar-dropdown" href="#" id="navbarDropdownMenuLink" data-toggle="dropdown" aria-haspopup="true" >
                                        Your Account
                                    </a>
                                    <div class="dropdown-menu topbar-dropdown-menu" style={{ position: 'absolute', right: '20px', left: '80%' }} aria-labelledby="navbarDropdownMenuLink">
                                       
                                        { localStorage.getItem('current_user_profile') !== null &&  localStorage.getItem('current_user_profile') === 'admin'?
                                        <span>
                                      {/*  <a id="submenu" class="dropdown-item submen" onMouseEnter={this.showSubmenu} onMouseLeave={this.hideMenu} href="#">Admin</a> 
                                        <div id='submenu-div' class="topbar-dropdown-menu" aria-labelledby="navbarDropdownMenuLink">
                                        <a class="dropdown-item" href="#" onClick={() => this.HandleRouting('users')}>Users</a> 
                                      <a class="dropdown-item" href="#" onClick={() => this.HandleRouting('organizers')}>Organizers</a> 
                                      
                                        </div>
                    */}
                                      <a class="dropdown-item" href="#" onClick={() => this.HandleRouting('users')}>Users</a> 
                                      <a class="dropdown-item" href="#" onClick={() => this.HandleRouting('organizers')}>Organizers</a> 
                                        <a class="dropdown-item" href="#" onClick={() => this.HandleRouting('sessions')}>Sessions</a>
                                        <a class="dropdown-item" href="#" onClick={() => this.HandleRouting('add-category')}>Category</a>
                                        <a class="dropdown-item" href="#" onClick={() => this.HandleRouting('tours')}>Tour</a>
                                        <a class="dropdown-item" href="#" onClick={() => this.HandleRouting('tour-lead')}>Tour Leads</a>
                                        </span>
                                        :''}
                                       <li> <a class="dropdown-item" href="#" onClick={() => this.HandleRouting('booked-sessions')}>My Sessions</a> </li>
                                      <li>  <a class="dropdown-item" href="#" onClick={this.Logout}>LogOut</a> </li>
                                    </div>
                                </div>

                                <div class='account-div-main-mobile' style={{ display: 'flex' }}>

                                    <i class="fa fa-lg fa-plus-circle" style={{ fontSize: '24px' }} 
                                    onClick={() => this.HandleRouting(`user-profile/${this.state.current_user_id}`)}
                                    aria-hidden="true"></i>
                                    <a class="nav-link dropdown-toggle topbar-dropdown" href="#" id="navbarDropdownMenuLink" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                        <i class="fa fa-user" style={{ fontSize: '24px' }} aria-hidden="true"></i>

                                    </a>
                                    <div class="dropdown-menu topbar-dropdown-menu" style={{ position: 'absolute', right: '20px', left: '80%' }} aria-labelledby="navbarDropdownMenuLink">
                                       
                                        {localStorage.getItem('current_user_profile') !== null && localStorage.getItem('current_user_profile') === 'admin'?
                                        <span>
                                        <a class="dropdown-item" href="#" onClick={() => this.HandleRouting('users')}>Users</a>
                                        <a class="dropdown-item" href="#" onClick={() => this.HandleRouting('organizers')}>Organizers</a>
                                        <a class="dropdown-item" href="#" onClick={() => this.HandleRouting('sessions')}>Sessions</a>
                                        <a class="dropdown-item" href="#" onClick={() => this.HandleRouting('add-category')}>Category</a>
                                        <a class="dropdown-item" href="#" onClick={() => this.HandleRouting('tours')}>Tour</a>
                                        <a class="dropdown-item" href="#" onClick={() => this.HandleRouting('tour-lead')}>Tour Leads</a>

                                        </span>
                                        :''}
                                        <a class="dropdown-item" href="#" onClick={() => this.HandleRouting('booked-sessions')}>My Sessions</a>
                                        <a class="dropdown-item" href="#" onClick={this.Logout}>LogOut</a>


                                    </div>
                                </div>

                            </div>

                    }

                </nav>
            </div>
        )
    }
}

export const TopBar = PnkConnect(topbar, '');